import { FC } from 'react';
import styled, { keyframes } from 'styled-components';

import { addMeasureType } from '~src/utils';

const Container = styled.div<{ $margin: number | string }>`
  margin-top: ${({ $margin }) => addMeasureType($margin)};
  line-height: normal;

  &.center {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  &.center-middle {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &.middle {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  &.page-cover {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.baseBlue.a10};
    z-index: 9999;
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }

  45% {
    transform: scale(0.1);
    opacity: 0.7;
  }

  80% {
    transform: scale(1);
    opacity: 1;
  }
`;

const Pulse = styled.div<{ $color?: string; $size: number; $margin?: number; $delay: number }>`
  background-color: ${({ $color, theme }) => {
    switch ($color) {
      case 'white':
        return theme.white.a10;
      case 'pink':
        return theme.red.a10;
      default:
        return theme.baseBlue.a10;
    }
  }};
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  margin-right: ${({ $margin = 0 }) => $margin}px;
  border-radius: 100%;
  display: inline-block;
  animation: ${pulse} 0.75s ${({ $delay }) => $delay * 0.12}s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
  animation-fill-mode: both;
`;

export type loadingSpinnerColors = 'white' | 'pink';

interface Props {
  color?: loadingSpinnerColors;
  size?: number;
  alignCls?: 'center' | 'middle' | 'center-middle' | 'page-cover' | 'no-align';
  loading?: boolean;
  marginTop?: string | number;
  dotsMargin?: number;
}

const LoadingSpinner: FC<Props> = ({
  color,
  size = 15,
  alignCls = 'center',
  loading = true,
  marginTop = '0',
  dotsMargin = 4,
}) => {
  return loading ? (
    <Container className={alignCls} $margin={marginTop}>
      <div>
        <Pulse $margin={dotsMargin} $size={size} $color={color} $delay={1} />
        <Pulse $margin={dotsMargin} $size={size} $color={color} $delay={2} />
        <Pulse $size={size} $color={color} $delay={3} />
      </div>
    </Container>
  ) : null;
};

export default LoadingSpinner;
